<template>
	<div id="main">
		<div @click="startTopic" class="btnClick">开始<br>答题</div>
		<img style="width: 100%;height: 100%;" src="../../../../../assets/image/rule.jpg" />
	</div>
</template>
<script>
	import {param,GetQueryString,getByteLen} from '@/utils/index.js'
	export default {
		data(){
			return {
				error:false,
				currTid:'gwtesting',
				currOpenid:'',
				person:sessionStorage.person?JSON.parse(sessionStorage.person):undefined
			}
		},
		created:function(){
			if(this.person==undefined){
				this.currOpenid=GetQueryString('openid');
				if(this.currOpenid==undefined||this.currOpenid==''){
					this.error=true;
					this.$Message.error('openid获取失败,请联系系统管理员');
					return ;
				}
				
				this.$http.get('person/queryOpenid?openid='+this.currOpenid,'').then((res)=> {
					if(res.code!='200'){
						this.$Message.error(res.msg);
						return ;
					}
					this.person=res.data==undefined?{}:res.data;
					this.person.tid=this.currTid;
					this.person.popenid=this.currOpenid;
					sessionStorage.person=JSON.stringify(this.person);
				});
			}
			
		},
		methods:{
			startTopic(){
				if(!this.error){
					if(this.person.pid==undefined){
						console.log('undefined')
						this.$router.push({name:'Binding',params:{returnName:'Topic'}});
						return ;
					}
					this.$router.push({name:'Topic'});
				}
			}
		},
		computed:{
		},
		watch:{	
		}
	}
</script>
<style>
	#main{
		width: 100%;
		height: 100%;
	}
	
	.btnClick{
		width: 50px;
		height: 50px;
		border-radius: 26px;
		background: #f8f8f9;
		text-align: center;
		padding-top: 7px;
		position: fixed;
		bottom: 16px;
		right: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Testing/index.vue